import { map, delay, takeUntil, debounceTime } from "rxjs/operators";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ContentChildren,
  QueryList,
  AfterContentInit,
  HostBinding,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { convertToBoolProperty } from "projects/sepidz-web-framework/src/lib/@core/utils/helpers";
import { Subject } from "rxjs";

@Component({
  selector: "ssg-tab",
  template: `
    <ng-container *ngIf="init">
      <ng-content></ng-content>
    </ng-container>
  `,
})
export class SsgTabComponent {
  @Input() tabTitle: string;

  @Input() tabIcon: string;

  @Input() route: string;

  @HostBinding("class.content-active")
  activeValue: boolean = false;

  @Input()
  get active() {
    return this.activeValue;
  }
  set active(val: boolean) {
    this.activeValue = convertToBoolProperty(val);
    if (this.activeValue) {
      this.init = true;
    }
  }

  @Input() isCloseable: boolean;

  init: boolean = false;
}

@Component({
  selector: "ssg-tabset",
  styleUrls: ["./tabset.component.scss"],
  templateUrl: "tabset.component.html",
})
export class SsgTabsetComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(SsgTabComponent) tabs: QueryList<SsgTabComponent>;

  @ViewChild("tabset", { static: false }) public widgetsContent: ElementRef<any>;

  @HostBinding("class.full-width") fullWidthValue = false;

  @Input() isTabsetRouter: any;

  changeIcon: boolean;

  @Input()
  set fullWidth(val: boolean) {
    this.fullWidthValue = convertToBoolProperty(val);
  }

  @Input() routeParam: string;

  ngUnsubscribe = new Subject<void>();

  @Output() changeTab = new EventEmitter<any>();
  @Output() tabChange = new EventEmitter<any>();
  @Output() oncloseAllTab = new EventEmitter<any>();
  @Output() oncloseTab = new EventEmitter<any>();

  constructor(private route: ActivatedRoute, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
  ngAfterContentInit() {
    this.route.params.pipe(takeUntil(this.ngUnsubscribe), debounceTime(0)).subscribe(() => {
      this.selectTab(this.tabs.first, 0);
      this.changeDetectorRef.markForCheck();
    });

    this.route.params
      .pipe(
        map((params: any) => this.tabs.find((tab) => (this.routeParam ? tab.route === params[this.routeParam] : tab.active))),
        delay(0)
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((activeTab) => {
        this.selectTab(activeTab || this.tabs.first, this.tabs.length - 1);
        this.changeDetectorRef.markForCheck();
      });
  }

  selectTab(selectedTab: SsgTabComponent, index: number) {
    if (selectedTab && !selectedTab.active) {
      this.tabs.forEach((tab) => {
        tab.init = tab === selectedTab;
        tab.active = tab === selectedTab;
      });
      this.changeTab.emit(index);
      this.tabChange.emit(selectedTab);
    }
  }
  closeTab(index: number) {
    this.oncloseTab.emit(index);
  }
  get enableBtn() {
    if (this.widgetsContent != undefined && this.widgetsContent?.nativeElement != undefined)
      return this.widgetsContent?.nativeElement?.scrollWidth > this.widgetsContent?.nativeElement?.offsetWidth;
  }
  public scrollRight(): void {
    if (this.widgetsContent != undefined && this.widgetsContent?.nativeElement != undefined)
      this.widgetsContent?.nativeElement?.scrollTo({ left: this.widgetsContent?.nativeElement?.scrollLeft + 40, behavior: "smooth" });
  }
  public scrollLeft(): void {
    if (this.widgetsContent != undefined && this.widgetsContent?.nativeElement != undefined)
      this.widgetsContent?.nativeElement?.scrollTo({ left: this.widgetsContent?.nativeElement?.scrollLeft - 40, behavior: "smooth" });
  }
  closeAllTabs() {
    this.oncloseAllTab.emit();
  }
}
